import { BrainIcon } from '@/components/icons';
import { Box, Typography } from '@mui/material';
import { RecordingControls } from '../../RecordingControls';
import { audioCardStyles } from '../../styles';

type RecordingState =
  | 'idle'
  | 'recording'
  | 'paused'
  | 'stopped'
  | 'processing';

interface RecordingStateProps {
  title: string;
  subtitle: string;
  recordingState: RecordingState;
  recordingTime: number;
  onStopRecording: () => void;
  onPauseResume: () => void;
  volumeLevel: number;
}

const RecordingStateComponent: React.FC<RecordingStateProps> = ({
  title,
  subtitle,
  recordingState,
  recordingTime,
  onStopRecording,
  onPauseResume,
  volumeLevel,
}) => {
  return (
    <Box sx={{ position: 'relative', height: '100%' }}>
      <Box sx={audioCardStyles.iconContainer}>
        <BrainIcon width={22} height={22} />
      </Box>

      <Typography variant="h5" sx={audioCardStyles.title}>
        {title}
      </Typography>

      <Typography variant="body1" sx={audioCardStyles.subtitle}>
        {subtitle}
      </Typography>

      <RecordingControls
        recordingState={recordingState}
        recordingTime={recordingTime}
        onStopRecording={onStopRecording}
        onPauseResume={onPauseResume}
        volumeLevel={volumeLevel}
      />
    </Box>
  );
};

export { RecordingStateComponent };

